/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
// exports.onClientEntry = () => {
//   // IntersectionObserver polyfill for gatsby-image (Safari, IE)
//   if (typeof window.IntersectionObserver === `undefined`) {
//     import(`intersection-observer`)
//   }
// }


// import { smoothScroll } from './src/modules/_scrolls'
import './src/sass/main.scss'


export const onClientEntry = async () => {
  // console.log('onClientEntry')
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
    // console.log(`👍 IntersectionObserver is polyfilled`)
  }else{
    // console.log(`👍👍👍👍 IntersectionObserver is polyfilled`)
  }
}


export const onInitialClientRender = async () => {
  // console.log('onInitialClientRender')
}

import Check from './src/util/intersectionObserverCheck';

export const onPostPrefetchPathname = async () => {
  // console.log('onPostPrefetchPathname')
  // smoothScroll('.js-scroll')
  Check()
}

export const onRouteUpdate  = async () => {
  // console.log('onRouteUpdate ')
  // smoothScroll('.js-scroll')
  Check()
}







/*
export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
  }
}*/
